<template>
  <div class="moveWavesWrap">
    <div class="moveWaves">
      <!-- <img :src="corrugatedBgImg"/>
      <img :src="corrugatedBgImg"/> -->
    </div>
  </div>
</template>

<script>
import corrugatedBgImg from '@/assets/img/corrugatedBg.png'

export default {
  name: 'moveWaves',
  data () {
    return {
      corrugatedBgImg
    }
  }
}
</script>

<style lang="stylus" scoped>
.moveWavesWrap
  position absolute
  left 0
  bottom 0
  width 100%
  height 425px
  overflow hidden
  pointer-events none
  .moveWaves
    width 200%
    height 100%
    background url('~assets/img/corrugatedBg.png') repeat-x
    background-size 1920px 425px
    animation toWaves 120s linear infinite

@keyframes toWaves
  0% 
    transform translateX(-50%)
  100% 
    transform translateX(0)
</style>